/**
 * @file Utilities for sorting and filtering data.
 */

import moment from 'moment-timezone';
import { getByDisplayKey } from './displayKeyUtil';

/**
 * Sort an array of bundle entries by most to least recent date value.
 * @param {Array} entries Bundle entries to sort.
 * @param {string} sortKey Display key pointing to a date value.
 * @param {string} fallbackSortKey Display key to use to sort entries if dates are the same. Property must be a string.
 * @returns {Array} New array with the elements in descending order by date value.
 */
export const sortByDateDescending = (
  entries = [],
  sortKey = '',
  fallbackSortKey = '',
) =>
  entries.toSorted((a, b) => {
    const aDate = moment(getByDisplayKey(a, sortKey));
    const bDate = moment(getByDisplayKey(b, sortKey));

    // Use fallback comparator if entries occur on the same day
    if (aDate.isSame(bDate, 'day')) {
      const aValue = getByDisplayKey(a, fallbackSortKey);
      const bValue = getByDisplayKey(b, fallbackSortKey);
      return aValue.localeCompare(bValue);
    }

    return bDate - aDate;
  });
